import { produce } from 'immer';
const generateCashOutPayload = (request, selected) => {
  const body = Object.values(selected).reduce((result, current) => {
    return Object.assign({}, result, current);
  }, {});
  const updated = produce(request, draft => {
    draft.productInfo.refinanceDetails.cashoutDetails.refinanceReason = body.refinanceReason ?? '';
    draft.productInfo.refinanceDetails.cashoutDetails.equityCash = body.equityCash ?? 0;
    populateBorrowerDetails(draft, body);
  });
  return updated;
};
const generateRefinancePayload = (request, selected) => {
  const body = Object.values(selected).reduce((result, current) => {
    return Object.assign({}, result, current);
  }, {});
  const updated = produce(request, draft => {
    if (draft.productInfo.type === 'RT') {
      draft.productInfo.refinanceDetails.rateTermDetails.refinanceReason = body.refinanceReason ?? '';
    }
    if (draft.productInfo.type === 'SL') {
      draft.productInfo.refinanceDetails.streamLineDetails.refinanceReason = body.refinanceReason ?? '';
    }
    populateBorrowerDetails(draft, body);
  });
  return updated;
};
const generatePurchasePayload = (request, selected) => {
  const body = Object.values(selected).reduce((result, current) => {
    return Object.assign({}, result, current);
  }, {});
  const updated = produce(request, draft => {
    draft.productInfo.purchaseDetails.puDetails.timeFrame = body.timeFrame ?? '';
    draft.productInfo.purchaseDetails.puDetails.state = body.propertyState ?? '';
    draft.productInfo.purchaseDetails.puDetails.usage = body.homeType;
    draft.productInfo.purchaseDetails.puDetails.homeType = body.propertyType;
    populateBorrowerDetails(draft, body);
  });
  return updated;
};
function populateBorrowerDetails(draft, body) {
  draft.borrowers[0].address.zipCode = body.address.zipCode;
  draft.borrowers[0].address.state = body.address.state;
  draft.borrowers[0].address.city = body.address.city;
  draft.borrowers[0].address.street2 = body.address.street2;
  draft.borrowers[0].address.street = body.address.street;
  draft.borrowers[0].firstName = body.firstName;
  draft.borrowers[0].lastName = body.lastName;
  draft.borrowers[0].phone = body.phoneNumber;
  draft.borrowers[0].email = body.email;
}
const AuthenticatedLeadFormsPayloadFunctions = {
  generateCashOutPayload,
  generateRefinancePayload,
  generatePurchasePayload
};
export default AuthenticatedLeadFormsPayloadFunctions;
//# sourceMappingURL=index.js.map